export default __webpack_public_path__ + "static/44aa-cd2cd55a0dde38c8ee2c741979d757ee.png";